import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';

const CITIES = ['Surrey', 'Vancouver', 'Langley', 'Coquitlam', 'Richmond', 'Burnaby', 'New Westminster', 'Delta', 'White Rock', 'North Vancouver', 'Port Coquitlam', 'Maple Ridge'];

export default function ServiceAreas() {
  return (
    <section id="areas" data-testid="service-areas-section" className="relative bg-obsidian grain py-24 lg:py-32 overflow-hidden">
      <div className="absolute top-0 right-0 w-[520px] h-[520px] rounded-full bg-mint/10 blur-[140px]" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-mint-vibrant mb-5">04 — Service Areas</p>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.7 }}
              className="font-display font-extrabold text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]"
            >
              Proudly serving
              <br />
              Metro Vancouver.
            </motion.h2>
          </div>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="text-stone-300/90 text-base lg:text-lg max-w-md leading-relaxed"
          >
            Homes and businesses across the Lower Mainland — and the surrounding
            communities beyond.
          </motion.p>
        </div>

        <div className="flex flex-wrap gap-3.5">
          {CITIES.map((city, i) => (
            <motion.span
              key={city}
              data-testid={`service-area-${city.toLowerCase().replace(/\s+/g, '-')}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="inline-flex items-center gap-2.5 bg-mint text-white font-display font-bold text-lg sm:text-xl px-7 py-3.5 rounded-full"
            >
              <MapPin size={17} />
              {city}
            </motion.span>
          ))}
          <motion.span
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.5, delay: 0.7 }}
            className="inline-flex items-center text-stone-400 font-mono text-xs px-3 py-3 tracking-wide"
          >
            …and surrounding communities
          </motion.span>
        </div>
      </div>
    </section>
  );
}
